import api from "PFCore/api";
import { Id } from "PFTypes";

type DataImportStatusParams = {
  accountId: Id;
  id: number;
};

export const fetchDataImportStatus = ({ accountId, id }: DataImportStatusParams) =>
  api({
    url: `saas_admin/accounts/${accountId}/data_imports/${id}`
  });
